export const sablierComptrollerAbi = [
  {
    type: "constructor",
    inputs: [{ name: "initialAdmin", type: "address", internalType: "address" }],
    stateMutability: "nonpayable",
  },
  { type: "receive", stateMutability: "payable" },
  {
    type: "function",
    name: "ATTESTOR_MANAGER_ROLE",
    inputs: [],
    outputs: [{ name: "", type: "bytes32", internalType: "bytes32" }],
    stateMutability: "view",
  },
  {
    type: "function",
    name: "FEE_COLLECTOR_ROLE",
    inputs: [],
    outputs: [{ name: "", type: "bytes32", internalType: "bytes32" }],
    stateMutability: "view",
  },
  {
    type: "function",
    name: "FEE_MANAGEMENT_ROLE",
    inputs: [],
    outputs: [{ name: "", type: "bytes32", internalType: "bytes32" }],
    stateMutability: "view",
  },
  {
    type: "function",
    name: "MAX_FEE_USD",
    inputs: [],
    outputs: [{ name: "", type: "uint256", internalType: "uint256" }],
    stateMutability: "view",
  },
  {
    type: "function",
    name: "MINIMAL_INTERFACE_ID",
    inputs: [],
    outputs: [{ name: "", type: "bytes4", internalType: "bytes4" }],
    stateMutability: "view",
  },
  {
    type: "function",
    name: "UPGRADE_INTERFACE_VERSION",
    inputs: [],
    outputs: [{ name: "", type: "string", internalType: "string" }],
    stateMutability: "view",
  },
  {
    type: "function",
    name: "VERSION",
    inputs: [],
    outputs: [{ name: "", type: "string", internalType: "string" }],
    stateMutability: "view",
  },
  {
    type: "function",
    name: "admin",
    inputs: [],
    outputs: [{ name: "", type: "address", internalType: "address" }],
    stateMutability: "view",
  },
  {
    type: "function",
    name: "attestor",
    inputs: [],
    outputs: [{ name: "", type: "address", internalType: "address" }],
    stateMutability: "view",
  },
  {
    type: "function",
    name: "calculateMinFeeWei",
    inputs: [
      { name: "protocol", type: "uint8", internalType: "enum ISablierComptroller.Protocol" },
    ],
    outputs: [{ name: "", type: "uint256", internalType: "uint256" }],
    stateMutability: "view",
  },
  {
    type: "function",
    name: "calculateMinFeeWeiFor",
    inputs: [
      { name: "protocol", type: "uint8", internalType: "enum ISablierComptroller.Protocol" },
      { name: "user", type: "address", internalType: "address" },
    ],
    outputs: [{ name: "", type: "uint256", internalType: "uint256" }],
    stateMutability: "view",
  },
  {
    type: "function",
    name: "convertUSDFeeToWei",
    inputs: [{ name: "feeUSD", type: "uint256", internalType: "uint256" }],
    outputs: [{ name: "", type: "uint256", internalType: "uint256" }],
    stateMutability: "view",
  },
  {
    type: "function",
    name: "disableCustomFeeUSDFor",
    inputs: [
      { name: "protocol", type: "uint8", internalType: "enum ISablierComptroller.Protocol" },
      { name: "user", type: "address", internalType: "address" },
    ],
    outputs: [],
    stateMutability: "nonpayable",
  },
  {
    type: "function",
    name: "execute",
    inputs: [
      { name: "target", type: "address", internalType: "address" },
      { name: "targetCallData", type: "bytes", internalType: "bytes" },
    ],
    outputs: [{ name: "result", type: "bytes", internalType: "bytes" }],
    stateMutability: "nonpayable",
  },
  {
    type: "function",
    name: "getMinFeeUSD",
    inputs: [
      { name: "protocol", type: "uint8", internalType: "enum ISablierComptroller.Protocol" },
    ],
    outputs: [{ name: "", type: "uint256", internalType: "uint256" }],
    stateMutability: "view",
  },
  {
    type: "function",
    name: "getMinFeeUSDFor",
    inputs: [
      { name: "protocol", type: "uint8", internalType: "enum ISablierComptroller.Protocol" },
      { name: "user", type: "address", internalType: "address" },
    ],
    outputs: [{ name: "", type: "uint256", internalType: "uint256" }],
    stateMutability: "view",
  },
  {
    type: "function",
    name: "grantRole",
    inputs: [
      { name: "role", type: "bytes32", internalType: "bytes32" },
      { name: "account", type: "address", internalType: "address" },
    ],
    outputs: [],
    stateMutability: "nonpayable",
  },
  {
    type: "function",
    name: "hasRoleOrIsAdmin",
    inputs: [
      { name: "role", type: "bytes32", internalType: "bytes32" },
      { name: "account", type: "address", internalType: "address" },
    ],
    outputs: [{ name: "", type: "bool", internalType: "bool" }],
    stateMutability: "view",
  },
  {
    type: "function",
    name: "initialize",
    inputs: [
      { name: "initialAdmin", type: "address", internalType: "address" },
      { name: "initialAirdropMinFeeUSD", type: "uint256", internalType: "uint256" },
      { name: "initialBobMinFeeUSD", type: "uint256", internalType: "uint256" },
      { name: "initialFlowMinFeeUSD", type: "uint256", internalType: "uint256" },
      { name: "initialLockupMinFeeUSD", type: "uint256", internalType: "uint256" },
      { name: "initialOracle", type: "address", internalType: "address" },
    ],
    outputs: [],
    stateMutability: "nonpayable",
  },
  {
    type: "function",
    name: "lowerMinFeeUSDForCampaign",
    inputs: [
      { name: "campaign", type: "address", internalType: "address" },
      { name: "newMinFeeUSD", type: "uint256", internalType: "uint256" },
    ],
    outputs: [],
    stateMutability: "nonpayable",
  },
  {
    type: "function",
    name: "oracle",
    inputs: [],
    outputs: [{ name: "", type: "address", internalType: "address" }],
    stateMutability: "view",
  },
  {
    type: "function",
    name: "proxiableUUID",
    inputs: [],
    outputs: [{ name: "", type: "bytes32", internalType: "bytes32" }],
    stateMutability: "view",
  },
  {
    type: "function",
    name: "revokeRole",
    inputs: [
      { name: "role", type: "bytes32", internalType: "bytes32" },
      { name: "account", type: "address", internalType: "address" },
    ],
    outputs: [],
    stateMutability: "nonpayable",
  },
  {
    type: "function",
    name: "setAttestor",
    inputs: [{ name: "newAttestor", type: "address", internalType: "address" }],
    outputs: [],
    stateMutability: "nonpayable",
  },
  {
    type: "function",
    name: "setAttestorForCampaign",
    inputs: [
      { name: "campaign", type: "address", internalType: "address" },
      { name: "newAttestor", type: "address", internalType: "address" },
    ],
    outputs: [],
    stateMutability: "nonpayable",
  },
  {
    type: "function",
    name: "setCustomFeeUSDFor",
    inputs: [
      { name: "protocol", type: "uint8", internalType: "enum ISablierComptroller.Protocol" },
      { name: "user", type: "address", internalType: "address" },
      { name: "customFeeUSD", type: "uint256", internalType: "uint256" },
    ],
    outputs: [],
    stateMutability: "nonpayable",
  },
  {
    type: "function",
    name: "setMinFeeUSD",
    inputs: [
      { name: "protocol", type: "uint8", internalType: "enum ISablierComptroller.Protocol" },
      { name: "newMinFeeUSD", type: "uint256", internalType: "uint256" },
    ],
    outputs: [],
    stateMutability: "nonpayable",
  },
  {
    type: "function",
    name: "setOracle",
    inputs: [{ name: "newOracle", type: "address", internalType: "address" }],
    outputs: [],
    stateMutability: "nonpayable",
  },
  {
    type: "function",
    name: "supportsInterface",
    inputs: [{ name: "interfaceId", type: "bytes4", internalType: "bytes4" }],
    outputs: [{ name: "", type: "bool", internalType: "bool" }],
    stateMutability: "view",
  },
  {
    type: "function",
    name: "transferAdmin",
    inputs: [{ name: "newAdmin", type: "address", internalType: "address" }],
    outputs: [],
    stateMutability: "nonpayable",
  },
  {
    type: "function",
    name: "transferFees",
    inputs: [
      { name: "protocolAddresses", type: "address[]", internalType: "address[]" },
      { name: "feeRecipient", type: "address", internalType: "address" },
    ],
    outputs: [],
    stateMutability: "nonpayable",
  },
  {
    type: "function",
    name: "upgradeToAndCall",
    inputs: [
      { name: "newImplementation", type: "address", internalType: "address" },
      { name: "data", type: "bytes", internalType: "bytes" },
    ],
    outputs: [],
    stateMutability: "payable",
  },
  {
    type: "function",
    name: "withdrawERC20Token",
    inputs: [
      { name: "token", type: "address", internalType: "contract IERC20" },
      { name: "to", type: "address", internalType: "address" },
    ],
    outputs: [],
    stateMutability: "nonpayable",
  },
  {
    type: "event",
    name: "Execute",
    inputs: [
      { name: "target", type: "address", indexed: true, internalType: "address" },
      { name: "targetCallData", type: "bytes", indexed: false, internalType: "bytes" },
      { name: "result", type: "bytes", indexed: false, internalType: "bytes" },
    ],
    anonymous: false,
  },
  {
    type: "event",
    name: "GrantRole",
    inputs: [
      { name: "admin", type: "address", indexed: true, internalType: "address" },
      { name: "account", type: "address", indexed: true, internalType: "address" },
      { name: "role", type: "bytes32", indexed: true, internalType: "bytes32" },
    ],
    anonymous: false,
  },
  {
    type: "event",
    name: "Initialized",
    inputs: [{ name: "version", type: "uint64", indexed: false, internalType: "uint64" }],
    anonymous: false,
  },
  {
    type: "event",
    name: "RoleRevoked",
    inputs: [
      { name: "admin", type: "address", indexed: true, internalType: "address" },
      { name: "account", type: "address", indexed: true, internalType: "address" },
      { name: "role", type: "bytes32", indexed: true, internalType: "bytes32" },
    ],
    anonymous: false,
  },
  {
    type: "event",
    name: "SetAttestor",
    inputs: [
      { name: "caller", type: "address", indexed: true, internalType: "address" },
      { name: "previousAttestor", type: "address", indexed: true, internalType: "address" },
      { name: "newAttestor", type: "address", indexed: true, internalType: "address" },
    ],
    anonymous: false,
  },
  {
    type: "event",
    name: "SetMinFeeUSD",
    inputs: [
      {
        name: "protocol",
        type: "uint8",
        indexed: true,
        internalType: "enum ISablierComptroller.Protocol",
      },
      { name: "caller", type: "address", indexed: false, internalType: "address" },
      { name: "previousMinFeeUSD", type: "uint256", indexed: false, internalType: "uint256" },
      { name: "newMinFeeUSD", type: "uint256", indexed: false, internalType: "uint256" },
    ],
    anonymous: false,
  },
  {
    type: "event",
    name: "SetOracle",
    inputs: [
      { name: "admin", type: "address", indexed: true, internalType: "address" },
      { name: "previousOracle", type: "address", indexed: false, internalType: "address" },
      { name: "newOracle", type: "address", indexed: false, internalType: "address" },
    ],
    anonymous: false,
  },
  {
    type: "event",
    name: "TransferAdmin",
    inputs: [
      { name: "oldAdmin", type: "address", indexed: true, internalType: "address" },
      { name: "newAdmin", type: "address", indexed: true, internalType: "address" },
    ],
    anonymous: false,
  },
  {
    type: "event",
    name: "TransferFees",
    inputs: [
      { name: "feeRecipient", type: "address", indexed: true, internalType: "address" },
      { name: "feeAmount", type: "uint256", indexed: false, internalType: "uint256" },
    ],
    anonymous: false,
  },
  {
    type: "event",
    name: "UpdateCustomFeeUSD",
    inputs: [
      {
        name: "protocol",
        type: "uint8",
        indexed: true,
        internalType: "enum ISablierComptroller.Protocol",
      },
      { name: "caller", type: "address", indexed: false, internalType: "address" },
      { name: "user", type: "address", indexed: true, internalType: "address" },
      { name: "previousMinFeeUSD", type: "uint256", indexed: false, internalType: "uint256" },
      { name: "newMinFeeUSD", type: "uint256", indexed: false, internalType: "uint256" },
    ],
    anonymous: false,
  },
  {
    type: "event",
    name: "Upgraded",
    inputs: [{ name: "implementation", type: "address", indexed: true, internalType: "address" }],
    anonymous: false,
  },
  {
    type: "event",
    name: "WithdrawERC20Token",
    inputs: [
      { name: "admin", type: "address", indexed: true, internalType: "address" },
      { name: "token", type: "address", indexed: true, internalType: "contract IERC20" },
      { name: "to", type: "address", indexed: true, internalType: "address" },
      { name: "amount", type: "uint256", indexed: false, internalType: "uint256" },
    ],
    anonymous: false,
  },
  {
    type: "error",
    name: "AccountAlreadyHasRole",
    inputs: [
      { name: "role", type: "bytes32", internalType: "bytes32" },
      { name: "account", type: "address", internalType: "address" },
    ],
  },
  {
    type: "error",
    name: "AccountDoesNotHaveRole",
    inputs: [
      { name: "role", type: "bytes32", internalType: "bytes32" },
      { name: "account", type: "address", internalType: "address" },
    ],
  },
  {
    type: "error",
    name: "AddressEmptyCode",
    inputs: [{ name: "target", type: "address", internalType: "address" }],
  },
  {
    type: "error",
    name: "CallerNotAdmin",
    inputs: [
      { name: "admin", type: "address", internalType: "address" },
      { name: "caller", type: "address", internalType: "address" },
    ],
  },
  {
    type: "error",
    name: "ERC1967InvalidImplementation",
    inputs: [{ name: "implementation", type: "address", internalType: "address" }],
  },
  { type: "error", name: "ERC1967NonPayable", inputs: [] },
  { type: "error", name: "FailedCall", inputs: [] },
  { type: "error", name: "InvalidInitialization", inputs: [] },
  { type: "error", name: "NotInitializing", inputs: [] },
  { type: "error", name: "SablierComptroller_ExecutionFailedSilently", inputs: [] },
  {
    type: "error",
    name: "SablierComptroller_FeeRecipientNotAdmin",
    inputs: [
      { name: "feeRecipient", type: "address", internalType: "address" },
      { name: "admin", type: "address", internalType: "address" },
    ],
  },
  { type: "error", name: "SablierComptroller_FeeRecipientZero", inputs: [] },
  {
    type: "error",
    name: "SablierComptroller_FeeTransferFailed",
    inputs: [
      { name: "feeRecipient", type: "address", internalType: "address" },
      { name: "feeAmount", type: "uint256", internalType: "uint256" },
    ],
  },
  {
    type: "error",
    name: "SablierComptroller_MaxFeeUSDExceeded",
    inputs: [
      { name: "newFeeUSD", type: "uint256", internalType: "uint256" },
      { name: "maxFeeUSD", type: "uint256", internalType: "uint256" },
    ],
  },
  { type: "error", name: "SablierComptroller_ToZeroAddress", inputs: [] },
  {
    type: "error",
    name: "SablierComptroller_TokenBalanceZero",
    inputs: [{ name: "token", type: "address", internalType: "address" }],
  },
  {
    type: "error",
    name: "SafeERC20FailedOperation",
    inputs: [{ name: "token", type: "address", internalType: "address" }],
  },
  { type: "error", name: "UUPSUnauthorizedCallContext", inputs: [] },
  {
    type: "error",
    name: "UUPSUnsupportedProxiableUUID",
    inputs: [{ name: "slot", type: "bytes32", internalType: "bytes32" }],
  },
  {
    type: "error",
    name: "UnauthorizedAccess",
    inputs: [
      { name: "caller", type: "address", internalType: "address" },
      { name: "neededRole", type: "bytes32", internalType: "bytes32" },
    ],
  },
] as const;
